<template>
  <div
    :class="[
      $style.container,
      {
        [$style.horizontal]: horizontalMenu,
      },
    ]"
  >
    <div
      v-for="(menuItem, idx) in menuList"
      :key="`menu_item_${idx}`"
      :class="$style.menu"
    >
      <base-button
        :class="[
          $style.button,
          {
            [$style.active]: menuItem.active,
            [$style.tooltip]: shownTooltip,
          },
        ]"
        :data-title="$t(menuItem.title)"
        @click="handleClick(menuItem.action)"
      >
        <span
          v-if="shownText"
          v-m-r="10"
          v-text="$t(menuItem.title)"
        ></span>
        <base-icon
          style="width: 40px; height: 40px;"
          :name="menuItem.icon"
        ></base-icon>
      </base-button>
    </div>
  </div>
</template>

<script>
import BaseButton from 'atoms/base/BaseButton';

import { HELP_URL } from 'root/.env';

export default {
  name: 'HeaderMenuList',
  components: {
    BaseButton,
  },
  props: {
    menuList: {
      type: Array,
      required: true,
    },
    horizontalMenu: {
      type: Boolean,
    },
    shownText: {
      type: Boolean,
      default: true,
    },
    shownTooltip: Boolean,
  },
  methods: {
    handleClick(action) {
      switch (action) {
        case 'profile':
          this.$router.push({ name: 'profile' });
          return;
        case 'theme':
          this.$emit('change-theme');
          return;
        case 'support': {
          let link = document.createElement('a');
          link.href = `${HELP_URL}/contact_us`;
          link.setAttribute('target', '_blank');
          link.click();
          return;
        }
        case 'logout':
          this.$emit('logout');
          return;
      }
    },
  },
};
</script>

<style lang="sass" module>
  @import '~styles/components/header/button'

  .container
    +flexbox
    +flex-direction(column)

    &.horizontal
      +flexbox
      +flex-direction(row)

  .menu
    +flexbox
    padding: 10px
</style>
